export default function stripQuery(str) {
  return str.replace(/^\?/, '')
}
